import { DEFAULT_BORDER } from 'constants/global';

import ComplianceDocument from 'assets/icons/compliance-document.svg';
import Operation from 'assets/icons/operation.svg';
import Sheild from 'assets/icons/sheild.svg';
import Finens from 'assets/icons/finens.svg';
import Adding from 'assets/icons/adding.svg';
import Flash from 'assets/icons/flash.svg';

const boxSize = {
  boxSize: 'unset',
  w: { mobile: 'full', xm: '340px', laptop: '600px', desktop: '670px' },
  minH: { mobile: '340px', laptop: '440px', desktop: '480px' },
  p: { mobile: '60px 24px 24px', laptop: '0 48px 48px' },
};
const grayCard = { bgColor: 'bg.gray', ...boxSize };
const neonLightCard = { bgColor: 'bg.neonLight', ...boxSize };
const whiteCard = {
  iconProps: { bgColor: 'bg.gray' },
  sx: { bgColor: 'bg.white', border: DEFAULT_BORDER, borderColor: 'bg.gray', ...boxSize },
};

export const cloudMigrationFirstExpertiseCardsSliderData = {
  textTitle: 'Зачем бизнесу нужна миграция в облако?',
  titleProps: { maxW: { mobile: '350px', tablet: '400px', laptop: '680px' } },
  cardsData: [
    {
      src: Sheild,
      title: 'Снижение простоев и отказоустойчивость',
      text: 'Облачные системы обеспечивают резервирование и доступность 24/7, минимизируют риск простоев',
      sx: neonLightCard,
    },
    {
      src: Finens,
      title: 'Рост прибыли',
      text: 'Половина компаний получают более 3% прибыли до вычета расходов (EBITDA) от перехода в облако. Для цифровых отраслей этот результат может превышать 5%',
      ...whiteCard,
    },
    {
      src: Adding,
      title: 'Масштабирование под рост бизнеса',
      text: 'Можно быстро увеличивать мощности или подключать новые сервисы без покупки серверов',
      sx: grayCard,
    },
    {
      src: Flash,
      title: 'Ускорение процессов',
      text: 'Облачные технологии ускоряют отчётность в 2+ раза и уменьшают нагрузку на поддержку на 20%',
      sx: neonLightCard,
    },
    {
      src: Operation,
      title: 'Гибкость и универсальность',
      text: 'Легко адаптировать инфраструктуру под разные бизнес‑процессы и новые проекты',
      ...whiteCard,
    },
    {
      src: ComplianceDocument,
      title: 'Безопасность и соответствие требованиям',
      text: 'Облачные площадки предлагают встроенные средства защиты данных и соответствие законодательным нормам',
      sx: grayCard,
    },
  ],
};
